/*
 * BreadcrumbsDropdown Messages
 *
 * This contains all the strings for the BreadcrumbsDropdown component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Button's text of the show more popup
  more: `{count, plural, one {one more} other {{count} more}}...`,
});
